import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
    fetchGet,
    isInteger,
    getDateForSrch,
    get12to24hourtme,
    getDateFormatted2,
    getDateFormatted3
} from "../../common/common";

import store from "../../store";

import LineInp from "../common/lineinput";
import Radio from "../common/radio";
import RadioBlock from "../common/radioBlock";
import Check from "../common/checkbox";
import Header from "../header/header";
import Footer from "../header/footer";
import HeaderSTA from "../header/headerSTA";
import FooterSTA from "../header/footerSTA";
import { apiUrl, color } from "../common/constants";
// import { Couponinfo, CouponArrow, Securelogo, WarningIcon } from '../common/icons/svg';
// import {
//   GiftIcon,
//   LockIcon,
//   PickupIcon,
//   DropoffIcon,
//   Busicon,
//   Clock,
// } from "../common/icons/svg";
import PastInput from "../pasthistoryInput/pasthistoryinput";
import {
    updateCheckoutDet,
    updateUserInfo,
    couponListDetails,
    updateHeaderText,
    updateOnwardFare,
    updateLevyAndConcession,
} from "../../actions/search-actions";
import PgBlock from "../common/pgBlock";
import { renderImg } from "../common/icons/img";
import LineInpDrop from "../common/lineInpDrop";
import { PostRequest } from "../common/helper";
import HeaderNew from "../header/HeaderNew";
import Checkbox from "../common/input/checkbox";
import AlertTerms from "../common/login/alertTerms";

class CheckoutNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            queryData: "{}",
            mobile: window.customerProfile ? window.customerProfile.MobileNumber : '',
            email: window.customerProfile ? window.customerProfile.EmailID : '',
            payopt: "",
            pgname: "",
            insuranceVal: 0,
            insurance: "on",
            onwardFare: 0,
            onwardGst: 0,
            onwardSc: 0,
            returnFare: 0,
            returnGst: 0,
            returnSc: 0,
            onwardPickcharges: 0,
            onwardDropcharges: 0,
            returnPickcharges: 0,
            returnDropcharges: 0,
            onwardRoundTripDiscount: 0,
            returnRoundTripDiscount: 0,
            onwardConvenienceCharge: 0,
            returnConvenienceCharge: 0,
            onwardInsuranceAmt: 0,
            returnInsuranceAmt: 0,
            roundTripdiscount: 0,
            discount: 0,
            isMobile: 0,
            activeTnC: false,
            discountAmt: 0,
            redeemCoupon: false,
            OTP: 0,
            CouponID: 0,
            CouponID2: 0,
            CouponID3: 0,
            CouponDiscount: 0,
            CouponDiscountAmt: 0,
            CouponDiscountAmt2: 0,
            CouponDiscountAmt3: 0,
            CouponDiscountType: "",
            CouponDiscountType2: "",
            CouponDiscountType3: "",
            customerGSTN:
                window.customerProfile && window.customerProfile.GSTN ? "on" : "off",
            companyGSTNo: window.customerProfile ? window.customerProfile.GSTN : "",
            regCompanyName: window.customerProfile
                ? window.customerProfile.GSTCompany
                : "",
            validCouponName: "",
            buttonLabel: "APPLY",
            countryCode: '+91',//window.country_code,
            countryCodeTYpe: window.msurl !== 'shwesanthu.com' ? "indian" : "myanmar",
            prepaidcoupon: "",
            loyaltyCoupon: "",
            marketingCoupon: "",
            updatedStax: 0,
            discountOnBase: 0,
            discountOnTotal: 0,
            bankChargesPer: 0,
            bankCharges: 0,
            showConfirm: false,
            showLoader: false,
            payBtnDisable: false,
            getCouponsDetails: false,
            showCouponblock: false,
            showPayeeBlock: true,
            activeCouponType: "prepaid",
            loyaltyCouponShow: 0,
            prepaidCouponShow: 1,
            discountCouponShow: 0,
            activeNavTab: "review",
            activeRtTab: "farebreakup",
            amountToPay: 0,
            travellerlist: false,
            payeedetail: false,
            isRoundtrip: false,
            showonwardsec: false,
            showreturnsec: false,
            customerName: window.customerProfile
                ? window.customerProfile.CustomerName
                : "",
            customerAge: window.customerProfile ? window.customerProfile.Age : 0,
            customerGender: window.customerProfile
                ? window.customerProfile.Gender === "M"
                    ? "Male"
                    : "Female"
                : "",

            alerterror: "",
            totalcouponAmount: 0,
            removeCoupon: false,
            removeCouponName: "",
            redeemCouponsList: "",
            bookingType: "",
            showServiceCharge: window.showServiceCharge,
            onwardTripSrt: 0,
            returnTripSrt: 0,
            onwardTripSrtConcession: 0,
            returnTripSrtConcession: 0,
            checkTandC: true,
            alredaySelPg: '',
            orderTimestamp: '',
            loginType: 'guest',
            password: '',
            openDrop: {
                'onward': { gender: false, concessionType: false, idCardType: false, country: false }, 'return': { gender: false, concessionType: false, idCardType: false, country: false },
            },
            openDropSeatNo: '',
            genderData: ['Male', 'Female', 'Others'],
            concessionData: [{ index: 0, value: 'General Public' }],
            nationality: ['India'],
            idCardData: ['PAN', 'AADHAR'],
            updatedOnwardFare: 0,
            updatedReturnFare: 0,
            onwardLevyAmount: 0,
            returnLevyAmount: 0,
            onwardConAmt: 0,
            returnConAmt: 0,
            onwardLevyConcData: {},
            returnLevyConcData: {},
            onwardConcList: [],
            tempOnwardConcList: [],
            returnConcList: [],
            tempReturnConcList: [],
            onwardConcessionType: {},
            returnConcessionType: {},
            tempOnwardConcessionType: {},
            tempReturnConcessionType: {},
            levyConcDetailsO: {},
            levyConcDetailsR: {},
            conAmtSeatsO: [],
            selMaxCon: [],
            tempMaxCon: [],
            concessionFilterFor: { age: false, gender: false },
            onwardConcessionUsed: [],
            returnConcessionUsed: [],
            reviewDetail: false,
            reviewEng: true,
            reviewKan: false,
            fareEng: true,
            fareKan: false,
            fareEngR: true,
            fareKanR: false,
            tcFlag: false,
            alertFlag: false,
        };
    }

    componentWillMount() {
        const ord = this.props.search.order;
        if (ord.length === 0) {
            let that = this;
            let savedOrderData = JSON.parse(localStorage.getItem('saveOrderdetail'));
            let orderData = savedOrderData.data;
            store.dispatch(updateCheckoutDet(orderData));
        }
    }

    componentDidMount() {
        var urlParams = new URLSearchParams(window.location.search);
        let ord = this.props.search.order;
        let mobile = this.props.search.contactDetail.mobile;
        let email = this.props.search.contactDetail.email;
        if (ord.length === 0) {
            let that = this;
            let savedOrderData = JSON.parse(localStorage.getItem('saveOrderdetail'));
            let savedPassData = JSON.parse(localStorage.getItem('savedPassDet'));
            savedPassData = savedPassData[that.props.match.params.token];
            // console.log("savedPassData", savedPassData);
            mobile = savedPassData.mobile;
            email = savedPassData.email;
            let orderData = savedOrderData.data;
            store.dispatch(updateCheckoutDet(orderData));

            setTimeout(() => {
                ord = this.props.search.order;
                let onwardFare = this.state.onwardFare;
                let onwardGst = this.state.onwardGst;
                let onwardSc = this.state.onwardSc;
                let returnFare = this.state.returnFare;
                let returnGst = this.state.returnGst;
                let returnSc = this.state.returnSc;
                let discount = this.state.discount;
                let onwardPickcharges = this.state.onwardPickcharges;
                let onwardDropcharges = this.state.onwardDropcharges;
                let returnPickcharges = this.state.returnPickcharges;
                let returnDropcharges = this.state.returnDropcharges;
                let onwardRoundTripDiscount = this.state.onwardRoundTripDiscount;
                let returnRoundTripDiscount = this.state.returnRoundTripDiscount;
                let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
                let returnConvenienceCharge = this.state.returnConvenienceCharge;
                let isRoundtrip = false;
                let headertext1 = "";
                let headertext2 = "";
                let onwardTripSrt = 0;
                let onwardTripSrtConcession = 0;
                let returnTripSrt = 0;
                let returnTripSrtConcession = 0;
                let onwardLevyAmount = 0;
                let returnLevyAmount = 0;
                let onwardConAmt = 0;
                let returnConAmt = 0;
                // headertext1 += ord.onward.fromCity + " ";
                // headertext1 += "- " + ord.onward.toCity;
                // headertext2 += moment(ord.onward.journeyDate + ' ' + ord.onward.boardingTime).format("HH:mm") + ", ";
                // headertext2 += getDateFormatted2(ord.onward.journeyDate) + " - ";
                // headertext2 += moment(ord.onward.arrivalDate + ' ' + ord.onward.arrivalTime).format("HH:mm") + ", ";
                // headertext2 += getDateFormatted2(ord.onward.arrivalDate);
                // store.dispatch(
                //     updateHeaderText({ text1: headertext1, text2: headertext2 })
                // );

                if (ord && ord.onward) {
                    Object.keys(ord.onward.seatDetails).forEach((el) => {
                        //ord.onward.seatDetails[el]["name"] = "";
                        //ord.onward.seatDetails[el]["age"] = "";
                        if (ord.onward.seatDetails[el].age <= 12) {
                            onwardFare += ord.onward.seatDetails[el].childFare;
                        } else {
                            onwardFare += ord.onward.seatDetails[el].fare;
                        }
                        // onwardFare += ord.onward.seatDetails[el].fare;
                        onwardGst += ord.onward.seatDetails[el].serviceTax
                            ? parseInt(ord.onward.seatDetails[el].serviceTax, 10)
                            : 0;

                        let levy = ord.onward.seatDetails[el].l || [];
                        if (levy.length > 0) {
                            levy.forEach(el => {
                                onwardLevyAmount += el.a;
                            })
                        }
                        let concession = ord.onward.seatDetails[el].c || [];
                        if (concession.length > 0) {
                            concession.forEach(el => onwardConAmt += el.a)
                        }
                    });
                    onwardSc += ord.onward.serviceCharge
                        ? parseInt(ord.onward.serviceCharge, 10)
                        : 0;
                    discount += ord.onward.discountAmount
                        ? parseInt(ord.onward.discountAmount, 10)
                        : 0;

                    onwardPickcharges = parseInt(ord.onward.pickupcharge, 10);
                    onwardDropcharges = parseInt(ord.onward.dropoffcharge, 10);
                    onwardRoundTripDiscount = parseInt(ord.onward.onwardRoundtripDiscont, 10);
                    onwardConvenienceCharge = parseInt(ord.onward.ConvenienceCharge, 10);

                }

                if (
                    ord.return &&
                    ord.return.seatDetails &&
                    Object.keys(ord.return.seatDetails).length > 0
                ) {

                    Object.keys(ord.return.seatDetails).forEach((el) => {
                        if (ord.return.seatDetails[el].age <= 12) {
                            returnFare += ord.return.seatDetails[el].childFare;
                        } else {
                            returnFare += ord.return.seatDetails[el].fare;
                        }
                        returnGst += ord.return.seatDetails[el].serviceTax
                            ? parseInt(ord.return.seatDetails[el].serviceTax, 10)
                            : 0;

                        let levy = ord.return.seatDetails[el].l || [];
                        if (levy.length > 0) {
                            levy.forEach(el => {
                                returnLevyAmount += el.a;
                            })
                        }
                        let concession = ord.return.seatDetails[el].c || [];
                        if (concession.length > 0) {
                            concession.forEach(el => returnConAmt += el.a)
                        }
                    });
                    returnSc += ord.return.serviceCharge
                        ? parseInt(ord.return.serviceCharge, 10)
                        : 0;
                    discount += ord.return.discountAmount
                        ? parseInt(ord.return.discountAmount, 10)
                        : 0;
                    isRoundtrip = true;
                }


                if (ord.return) {
                    returnPickcharges = parseInt(ord.return.pickupcharge2, 10);
                    returnDropcharges = parseInt(ord.return.dropoffcharge2, 10);
                    returnRoundTripDiscount = parseInt(
                        ord.return.returnRoundtripDiscont,
                        10
                    );
                    returnConvenienceCharge = parseInt(ord.return.ConvenienceCharge2, 10);
                }
                const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount > 0) ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0;

                let discountAmt;
                if (ord.return && ord.return.discountAmount) {
                    discountAmt =
                        parseInt(ord.onward.discountAmount, 10) +
                        parseInt(ord.return.discountAmount, 10);
                } else {
                    discountAmt = ord && ord.onward && ord.onward.discountAmount;
                }
                ord && Object.keys(ord).length > 0 && this.setDefaultpg(ord.pgDetails);

                const count =
                    ord && ord.onward && ord.onward.seats.length +
                    (ord.return && ord.return.seats ? ord.return.seats.length : 0);
                const insurance = ord && ord.showInsurance ? "on" : "off";
                const insuranceVal = ord && ord.showInsurance ? count * ord.insuranceAmt : 0;
                const onwardInsuranceAmt = ord && ord.showInsurance ? ord.onward.seats.length * ord.insuranceAmt : 0;
                const returnInsuranceAmt = (ord && ord.showInsurance && ord.return && ord.return.seats) ? ord.return.seats.length * ord.insuranceAmt : 0;

                const queryData = JSON.stringify({
                    hop: "direct",
                    mode: returnFare ? "roundtrip" : "oneway",
                    otaId: "0",
                    FromCityId: "",
                    ToCityId: "",
                    fromCityName: ord && ord.onward && ord.onward.fromCity,
                    toCityName: ord && ord.onward && ord.onward.toCity,
                    JourneyDate: ord && ord.onward && ord.onward.journeyDate,
                    NoOfSeats: false,
                    SearchId: 0,
                    returnDate: false,
                });
                this.setState({
                    insurance,
                    insuranceVal,
                    onwardInsuranceAmt,
                    returnInsuranceAmt,
                    onwardFare,
                    onwardGst,
                    onwardSc,
                    returnFare,
                    returnGst,
                    returnSc,
                    queryData,
                    discount,
                    discountAmt,
                    onwardPickcharges,
                    onwardDropcharges,
                    returnPickcharges,
                    returnDropcharges,
                    onwardRoundTripDiscount,
                    returnRoundTripDiscount,
                    onwardConvenienceCharge,
                    returnConvenienceCharge,
                    roundTripdiscount,
                    isRoundtrip,
                    onwardTripSrt,
                    onwardTripSrtConcession,
                    returnTripSrt,
                    returnTripSrtConcession,
                    updatedOnwardFare: onwardFare,
                    updatedReturnFare: returnFare,
                    onwardLevyAmount,
                    returnLevyAmount,
                    onwardConAmt,
                    returnConAmt,
                    mobile,
                    email,
                });
            }, 1000)

        } else {
            let onwardFare = this.state.onwardFare;
            let onwardGst = this.state.onwardGst;
            let onwardSc = this.state.onwardSc;
            let returnFare = this.state.returnFare;
            let returnGst = this.state.returnGst;
            let returnSc = this.state.returnSc;
            let discount = this.state.discount;
            let onwardPickcharges = this.state.onwardPickcharges;
            let onwardDropcharges = this.state.onwardDropcharges;
            let returnPickcharges = this.state.returnPickcharges;
            let returnDropcharges = this.state.returnDropcharges;
            let onwardRoundTripDiscount = this.state.onwardRoundTripDiscount;
            let returnRoundTripDiscount = this.state.returnRoundTripDiscount;
            let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
            let returnConvenienceCharge = this.state.returnConvenienceCharge;
            let isRoundtrip = false;
            let headertext1 = "";
            let headertext2 = "";
            let onwardTripSrt = 0;
            let onwardTripSrtConcession = 0;
            let returnTripSrt = 0;
            let returnTripSrtConcession = 0;
            let onwardLevyAmount = 0;
            let returnLevyAmount = 0;
            let onwardConAmt = 0;
            let returnConAmt = 0;
            // headertext1 += ord.onward.fromCity + " ";
            // headertext1 += "- " + ord.onward.toCity;
            // headertext2 += moment(ord.onward.journeyDate + ' ' + ord.onward.boardingTime).format("HH:mm") + ", ";
            // headertext2 += getDateFormatted2(ord.onward.journeyDate) + " - ";
            // headertext2 += moment(ord.onward.arrivalDate + ' ' + ord.onward.arrivalTime).format("HH:mm") + ", ";
            // headertext2 += getDateFormatted2(ord.onward.arrivalDate);
            // store.dispatch(
            //     updateHeaderText({ text1: headertext1, text2: headertext2 })
            // );
            Object.keys(ord.onward.seatDetails).forEach((el) => {
                //ord.onward.seatDetails[el]["name"] = "";
                //ord.onward.seatDetails[el]["age"] = "";

                if (ord.onward.seatDetails[el].age <= 12) {
                    onwardFare += ord.onward.seatDetails[el].childFare;
                } else {
                    onwardFare += ord.onward.seatDetails[el].fare;
                }
                onwardGst += ord.onward.seatDetails[el].serviceTax
                    ? parseInt(ord.onward.seatDetails[el].serviceTax, 10)
                    : 0;

                let levy = ord.onward.seatDetails[el].l || [];
                if (levy.length > 0) {
                    levy.forEach(el => {
                        onwardLevyAmount += el.a;
                    })
                }
                let concession = ord.onward.seatDetails[el].c || [];
                if (concession.length > 0) {
                    concession.forEach(el => onwardConAmt += el.a)
                }
            });
            onwardSc += ord.onward.serviceCharge
                ? parseInt(ord.onward.serviceCharge, 10)
                : 0;
            discount += ord.onward.discountAmount
                ? parseInt(ord.onward.discountAmount, 10)
                : 0;
            if (
                ord.return &&
                ord.return.seatDetails &&
                Object.keys(ord.return.seatDetails).length > 0
            ) {

                Object.keys(ord.return.seatDetails).forEach((el) => {
                    if (ord.return.seatDetails[el].age <= 12) {
                        returnFare += ord.return.seatDetails[el].childFare;
                    } else {
                        returnFare += ord.return.seatDetails[el].fare;
                    }
                    returnGst += ord.return.seatDetails[el].serviceTax
                        ? parseInt(ord.return.seatDetails[el].serviceTax, 10)
                        : 0;

                    let levy = ord.return.seatDetails[el].l || [];
                    if (levy.length > 0) {
                        levy.forEach(el => {
                            returnLevyAmount += el.a;
                        })
                    }
                    let concession = ord.return.seatDetails[el].c || [];
                    if (concession.length > 0) {
                        concession.forEach(el => returnConAmt += el.a)
                    }
                });
                returnSc += ord.return.serviceCharge
                    ? parseInt(ord.return.serviceCharge, 10)
                    : 0;
                discount += ord.return.discountAmount
                    ? parseInt(ord.return.discountAmount, 10)
                    : 0;
                isRoundtrip = true;
            }
            onwardPickcharges = parseInt(ord.onward.pickupcharge, 10);
            onwardDropcharges = parseInt(ord.onward.dropoffcharge, 10);
            onwardRoundTripDiscount = parseInt(ord.onward.onwardRoundtripDiscont, 10);
            onwardConvenienceCharge = parseInt(ord.onward.ConvenienceCharge, 10);

            if (ord.return) {
                returnPickcharges = parseInt(ord.return.pickupcharge2, 10);
                returnDropcharges = parseInt(ord.return.dropoffcharge2, 10);
                returnRoundTripDiscount = parseInt(
                    ord.return.returnRoundtripDiscont,
                    10
                );
                returnConvenienceCharge = parseInt(ord.return.ConvenienceCharge2, 10);
            }
            const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount > 0) ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0;
            const count =
                ord.onward.seats.length +
                (ord.return && ord.return.seats ? ord.return.seats.length : 0);
            const insurance = ord.showInsurance ? "on" : "off";
            const insuranceVal = ord.showInsurance ? count * ord.insuranceAmt : 0;
            const onwardInsuranceAmt = ord.showInsurance ? ord.onward.seats.length * ord.insuranceAmt : 0;
            const returnInsuranceAmt = (ord.showInsurance && ord.return && ord.return.seats) ? ord.return.seats.length * ord.insuranceAmt : 0;

            const queryData = JSON.stringify({
                hop: "direct",
                mode: returnFare ? "roundtrip" : "oneway",
                otaId: "0",
                FromCityId: "",
                ToCityId: "",
                fromCityName: ord.onward.fromCity,
                toCityName: ord.onward.toCity,
                JourneyDate: ord.onward.journeyDate,
                NoOfSeats: false,
                SearchId: 0,
                returnDate: false,
            });

            let discountAmt;
            if (ord.return && ord.return.discountAmount) {
                discountAmt =
                    parseInt(ord.onward.discountAmount, 10) +
                    parseInt(ord.return.discountAmount, 10);
            } else {
                discountAmt = ord.onward.discountAmount;
            }
            this.setDefaultpg(ord.pgDetails);
            this.setState({
                insurance,
                insuranceVal,
                onwardInsuranceAmt,
                returnInsuranceAmt,
                onwardFare,
                onwardGst,
                onwardSc,
                returnFare,
                returnGst,
                returnSc,
                queryData,
                discount,
                discountAmt,
                onwardPickcharges,
                onwardDropcharges,
                returnPickcharges,
                returnDropcharges,
                onwardRoundTripDiscount,
                returnRoundTripDiscount,
                onwardConvenienceCharge,
                returnConvenienceCharge,
                roundTripdiscount,
                isRoundtrip,
                onwardTripSrt,
                onwardTripSrtConcession,
                returnTripSrt,
                returnTripSrtConcession,
                updatedOnwardFare: onwardFare,
                updatedReturnFare: returnFare,
                onwardLevyAmount,
                returnLevyAmount,
                onwardConAmt,
                returnConAmt,
                mobile,
                email
            });
        }

        this.deafultSelData();

    }

    deafultSelData = (data) => {
        let that = this;
        const ord = that.props.search.order;
        const onwardloop = ord.length !== 0 ? ord.onward.seats : false;
        const returnloop = ord.length !== 0 ? ord.onward.seats && ord.return && ord.return.seats : false;
        if (data && data.pgSelected) {
            const savedPassData = that.getSavedData();
            const seats = savedPassData && savedPassData.onward && savedPassData.onward.seatDetails;
            const returnSeats = savedPassData && savedPassData.return && savedPassData.return.seatDetails;
            const alredaySelPg = data.pgSelected;
            const orderTimestamp = data.timestamp;
            const mobile = savedPassData.mobile;
            const email = savedPassData.email;
            if (onwardloop && seats) {
                onwardloop.map((el) => {
                    store.dispatch(updateUserInfo("name", "onward", el, seats[el].name)),
                        store.dispatch(updateUserInfo("age", "onward", el, seats[el].age)),
                        store.dispatch(updateUserInfo("gender", "onward", el, seats[el].gender)),
                        store.dispatch(updateUserInfo("concessionType", "onward", el, seats[el].concessionType)),
                        store.dispatch(updateUserInfo("idCardType", "onward", el, seats[el].idCardType)),
                        store.dispatch(updateUserInfo("idCardNo", "onward", el, seats[el].idCardNo)),
                        store.dispatch(updateUserInfo("nationality", "onward", el, seats[el].nationality))
                })
            }

            if (returnloop) {
                returnloop.map((el) => {
                    store.dispatch(updateUserInfo("name", "return", el, returnSeats[el].name)),
                        store.dispatch(updateUserInfo("age", "return", el, returnSeats[el].age)),
                        store.dispatch(updateUserInfo("gender", "return", el, returnSeats[el].gender)),
                        store.dispatch(updateUserInfo("concessionType", "onward", el, returnSeats[el].concessionType)),
                        store.dispatch(updateUserInfo("idCardType", "onward", el, returnSeats[el].idCardType)),
                        store.dispatch(updateUserInfo("idCardNo", "onward", el, returnSeats[el].idCardNo)),
                        store.dispatch(updateUserInfo("nationality", "onward", el, returnSeats[el].nationality))
                })
            }

            this.setState({ mobile, email, alredaySelPg, orderTimestamp, travellerlist: true, payeedetail: true, activeNavTab: "payment", payopt: alredaySelPg });
        }
    }

    setDefaultpg = (val) => {
        val.map((el, index) => {
            if (el.IsDefault) {
                this.setState({
                    payopt: el.pg,
                    bankChargesPer: el.BankCharges,
                    pgname: el.DisplayText,
                });
            }
        });
        return true;
    };

    handleClick = (divName) => {
        this.state.activeTnC === false
            ? this.setState({
                activeTnC: divName,
            })
            : this.setState({
                activeTnC: false,
            });
    };

    showTime = (time) => {
        const d = new Date(time);
        const d1 = new Date(d.setMinutes(d.getMinutes() + 20));
        let hour = d1.getHours();
        let mins = d1.getMinutes();
        let AMPM = hour >= 12 ? `PM` : 'AM';
        hour = hour > 12 ? hour - 12 : hour;
        const timeFormat = (hour > 10 ? hour : `0${hour}`) + ':' + (mins > 10 ? mins : `0${mins}`) + ` ${AMPM}`
        return timeFormat;
    }

    selPaymentOption = () => {

        const TotalFare =
            this.state.updatedOnwardFare +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges;

        let couponDiscount = parseInt(
            this.state.CouponDiscountAmt +
            this.state.CouponDiscountAmt2 +
            this.state.CouponDiscountAmt3 +
            this.state.roundTripdiscount +
            this.state.discount,
            10
        );

        const alredaySelPg = this.state.alredaySelPg;
        const orderTimestamp = this.state.orderTimestamp;

        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first remove open ticket discount amount from total discount given 
                couponDiscount = couponDiscount - otDisAmt;
                otDisAmt = onwardTripFare;
                //now add new open ticket discount amount in total discount given
                couponDiscount = couponDiscount + otDisAmt;
            }
        }

        if (TotalFare !== couponDiscount) {
            if (
                this.props.search.order &&
                this.props.search.order.pgDetails &&
                this.props.search.order.pgDetails.length > 0
            ) {
                const loop = this.props.search.order.pgDetails;
                const items = [];
                for (const [index, value] of loop.entries()) {
                    items.push(
                        <div key={index} className="pay-opts-item">

                            <PgBlock
                                value={value.pg}
                                selected={this.state.payopt === value.pg ? true : false}
                                onClick={(event) => {
                                    this.setState({
                                        payopt: value.pg,
                                        bankChargesPer: value.BankCharges,
                                        payBtnDisable: false,
                                        pgname: value.pg,
                                        checkTandC: true,
                                    });
                                }}
                                name="PGType"
                            />
                        </div>
                    );
                }
                return (
                    <React.Fragment>
                        <div className="card">
                            <div className="pay-opts">{items}</div>
                            <div className="checkout_tandc" style={{ display: 'flex', marginTop: '20px', fontWeight: '500', fontSize: '14px' }}>
                                <div>
                                    <Checkbox
                                        active={this.state.tcFlag}
                                        onClick={() => this.setState({ tcFlag: !this.state.tcFlag })}
                                    />
                                </div>
                                <div style={{ marginLeft: '10px' }}>I agree to KSRTC's <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Terms & Conditions</a>{/*  and <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Privacy Policy</a> */}</div>
                            </div>
                        </div>
                        {alredaySelPg && orderTimestamp &&
                            <div>

                                <div className="warning--wrapper">
                                    <div style={{ display: 'flex', justifyContent: 'center', paddingRight: '6px' }}>{renderImg('paymentMsg')}</div>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            lineHeight: '20px',
                                            color: '#1EB24B'
                                        }}
                                    >We can take up to 20 minutes to get payment confirmation</div>
                                </div>
                            </div>
                        }
                        {this.showPayBtn()}
                        {/* <table>{table}</table> */}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <div className="card">
                            <div className="flex-all-c secure-msg">
                                {/* <Securelogo /> */}
                                {renderImg('Securelogo')}
                            </div>
                        </div>
                        {this.showPayBtn()}
                    </React.Fragment>
                );
            }
        } else {
            return (
                <div className="card">
                    <div>
                        By clicking on "Proceed" below, I agree to the{" "}
                        <a
                            href="/terms_and_conditions"
                            target="_blank"
                            style={{ color: color.primary }}
                        >
                            Terms and Conditions
                        </a>
                    </div>
                    {this.showPayBtn()}
                </div>
            );
        }
    };

    isInLocalList(passengerentry) {
        let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
        LocalList.map((el) => { });
        for (var i = 0; i < LocalList.length; i++) {
            if (this.checkequality(passengerentry, LocalList[i])) {
                return true;
            }
        }
        return false;
    }
    checkequality(a, b) {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
        if (aProps.length !== bProps.length) {
            return false;
        }
        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];
            if (a[propName] !== b[propName]) {
                return false;
            }
        }
        if (a != []) {
            return true;
        } else {
            return false;
        }
    }
    showPayBtn = () => {

        const TotalFare = this.state.updatedOnwardFare + this.state.updatedReturnFare + this.state.onwardSc + this.state.returnSc + this.state.insuranceVal;
        let couponDiscount = parseInt(this.state.CouponDiscountAmt + this.state.CouponDiscountAmt2 + this.state.CouponDiscountAmt3 + this.state.roundTripdiscount + this.state.discount, 10);

        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first remove open ticket discount amount from total discount given 
                couponDiscount = couponDiscount - otDisAmt;
                otDisAmt = onwardTripFare;
                //now add new open ticket discount amount in total discount given
                couponDiscount = couponDiscount + otDisAmt;
            }
        }

        let isActive = false;
        const ord =
            this.props.search.order.length !== 0 ? this.props.search.order : false;
        const currency = this.props.search.currency;
        const amountToPay = this.amountToPayBlock();
        const bankCharges = this.bankChargesCalculationBlock();
        if (ord) {
            let temp = true;
            let conc = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach((el) => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
            });

            Object.keys(onwards).forEach((el) => {
                if (onwards[el].concessionType && onwards[el].concessionType !== 'GENERAL PUBLIC') {
                    if (!onwards[el].concessionType && !onwards[el].idCardType && !onwards[el].idCardType) {
                        temp = false;
                    }
                }

            });

            if (temp && ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach((el) => {
                    if (!returns[el].name || !returns[el].age || !returns[el].gender) {
                        temp = false;
                    }
                });
                Object.keys(returns).forEach((el) => {
                    if (returns[el].concessionType && returns[el].concessionType !== 'GENERAL PUBLIC') {
                        if (returns[el].concessionType && !returns[el].idCardType && !returns[el].idCardType) {
                            temp = false;
                        }
                    }
                });
            }
            let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.email
            );
            let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
            let indianMobNo =
                (this.state.mobile + "").length === 10 &&
                /^[0]?[6789]\d{9}$/.test(this.state.mobile);
            let internationalNo =
                (this.state.mobile + "").length < 20 &&
                /^[0-9\-]+$/.test(this.state.mobile);
            let mobile =
                countryCode && this.state.countryCode === "+91"
                    ? indianMobNo
                    : internationalNo;
            if (
                temp &&
                email &&
                this.state.email.length > 0 &&
                mobile &&
                countryCode
            ) {
                isActive = true;
            }
        }

        if (ord && TotalFare === couponDiscount) {
            return (
                <div
                    className="flex-all-c navswitchbtn"
                    style={{
                        color: !isActive ? "#666" : "#fff",
                        background: !isActive ? "#ddd" : color.secondary,
                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                        fontWeight: 500,
                        cursor: "pointer",
                        userSelect: "none",
                        left: 0,
                        bottom: 0,
                        position: "absolute",
                    }}
                    onClick={this.checkPayment}
                >
                    Confirm Booking
                </div>
            );
        } else if (TotalFare === couponDiscount) {
            return (
                <div
                    className="flex-all-c navswitchbtn"
                    style={{
                        color: !isActive ? "#666" : "#fff",
                        background: !isActive ? "#ddd" : color.secondary,
                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                        fontWeight: 500,
                        cursor: "pointer",
                        userSelect: "none",
                        left: 0,
                        bottom: 0,
                        position: "absolute",
                    }}
                    onClick={this.checkPayment}
                >
                    Confirm Booking
                </div>
            );
        } else if (this.state.payopt || (ord && ord.pgDetails.length === 0)) {
            return (
                <div
                    className="flex-all-c navswitchbtn"
                    style={{
                        color: !isActive ? "#666" : "#fff",
                        background: !isActive ? "#ddd" : color.secondary,
                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                        fontWeight: 500,
                        cursor: "pointer",
                        userSelect: "none",
                        left: 0,
                    }}
                    onClick={this.checkPayment}
                >
                    PAY {currency + " " + (amountToPay + bankCharges)} THROUGH{" "}
                    {this.state.pgname}
                </div>
            );
        } else {
            return (
                <div
                    className="flex-all-c navswitchbtn"
                    style={{
                        color: !isActive ? "#666" : "#fff",
                        background: !isActive ? "#ddd" : color.secondary,
                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                        fontWeight: 500,
                        cursor: "pointer",
                        userSelect: "none",
                        left: 0,
                    }}
                >
                    MAKE PAYMENT
                </div>
            );
        }
    };

    showOnwardTripDetails = () => {
        const info =
            this.props.search.order.length !== 0
                ? this.props.search.order.onward
                : false;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromstoptocity = urlParams.get("linkfromstoptocity");
        if (info) {
            return (
                <div>
                    <div className="">
                        <div className="loc-info pick" style={{ paddingTop: '16px' }}>
                            <div style={{ marginBottom: '12px', color: '#202020' }}>{`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip Details</div>
                            <div className="flex pick-up-label">
                                <div className="pickdecor">
                                    <div className="circleshape"></div>
                                </div>
                                Pickup at {info.fromCity} on {moment(info.journeyDate + ' ' + info.boardingTime).format("HH:mm")}
                                {", "}
                                {getDateFormatted3(info.journeyDate)}
                            </div>
                            <div className="loc-box flex">
                                <div className="pickdecor">
                                    <div className="verticle-line"></div>
                                </div>
                                <div style={{ marginTop: '4px' }}>
                                    <div className="pickdropaddress">{info.boardingPoint}</div>
                                </div>
                            </div>
                        </div>
                        <div className="loc-info drop" style={{ paddingBottom: 0 }}>
                            <div className="flex drop-off-label">
                                <div className="pickdecor">
                                    <div className="squareshape"></div>
                                </div>
                                Dropoff at {info.toCity} on {moment(info.arrivalDate + ' ' + info.arrivalTime).format("HH:mm")}
                                {", "}
                                {getDateFormatted3(info.arrivalDate)}
                            </div>
                            <div className="loc-box flex">
                                <div className="pickdecor"></div>
                                <div style={{ marginTop: '4px' }}>
                                    <div className="pickdropaddress">{info.dropPoint}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="flex">
                            {/* <Busicon className="mspacerite" /> */}
                            {renderImg('Busicon')}
                            {info.companyName}
                            {/* {info.suffix ? ' - ' + info.suffix.toUpperCase() : ''} */}
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div className="side-info">Loading...</div>;
        }
    };

    showReturnTripDetails = () => {
        const info = this.props.search.order.return;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromstoptocity = urlParams.get("linkfromstoptocity");
        return (
            <div>
                <div className="" style={{ borderTop: "1px solid #ddd", marginTop: "24px" }}>
                    <div className="loc-info pick" style={{ marginTop: '24px', paddingTop: 0 }}>
                        <div style={{ marginBottom: '12px', color: '#202020' }}>{`${linkfromstoptocity ? 'Connect' : 'Return'}`} Trip Details</div>
                        <div className="flex pick-up-label">
                            <div className="pickdecor">
                                <div className="circleshape"></div>
                            </div>
                            Pickup at {info.fromCity} on {moment(info.journeyDate + ' ' + info.boardingTime).format("HH:mm")}
                            {", "}
                            {getDateFormatted3(info.journeyDate)}
                        </div>
                        <div className="loc-box flex">
                            <div className="pickdecor">
                                <div className="verticle-line"></div>
                            </div>
                            <div style={{ marginTop: '4px' }}>
                                <div className="pickdropaddress">{info.boardingPoint}</div>
                            </div>
                        </div>
                    </div>
                    <div className="loc-info drop" style={{ paddingBottom: 0 }}>
                        <div className="flex drop-off-label">
                            <div className="pickdecor">
                                <div className="squareshape"></div>
                            </div>
                            Dropoff at {info.toCity} on {moment(info.arrivalDate + ' ' + info.arrivalTime).format("HH:mm")}
                            {", "}
                            {getDateFormatted3(info.arrivalDate)}
                        </div>
                        <div className="loc-box flex">
                            <div className="pickdecor"></div>
                            <div style={{ marginTop: '4px' }}>
                                <div className="pickdropaddress">{info.dropPoint}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex">
                        {/* <Busicon className="mspacerite" /> */}
                        {renderImg('Busicon')}
                        {info.companyName}
                    </div>
                </div>
            </div>
        );
    };

    showKsrtcOnwardPassDetails = () => {
        const loop =
            this.props.search.order.length !== 0
                ? this.props.search.order.onward.seatDetails
                : false;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromstoptocity = urlParams.get("linkfromstoptocity");
        if (loop) {
            return (
                <React.Fragment>
                    {(
                        <div className="roundtripshort onwrad--trip-bg flexed-justify">
                            <div className="item-desc">
                                {`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip ({Object.keys(loop).length > 1 ? Object.keys(loop).length + ' Berths' : Object.keys(loop).length + ' Berth'})
                            </div>
                            <div className="basefare">
                                {this.props.search.currency}
                                {this.state.updatedOnwardFare - this.state.onwardGst}
                            </div>
                            <div className="gst">
                                {this.props.search.currency}
                                {this.state.onwardGst}
                            </div>
                            <div className="total">
                                {this.props.search.currency}
                                {
                                    this.state.updatedOnwardFare
                                    //+ this.state.onwardPickcharges +
                                    //this.state.onwardDropcharges +
                                    //this.state.insuranceVal +
                                    // this.state.onwardGst +
                                    //this.state.onwardSc -
                                    //this.state.roundTripdiscount -
                                    //this.state.discount -
                                    // this.state.CouponDiscountAmt -
                                    // this.state.CouponDiscountAmt2 -
                                    // this.state.CouponDiscountAmt3 -
                                    //this.bankChargesCalculationBlock()
                                }
                            </div>
                            <div
                                className={`togglebutton ${this.state.showonwardsec ? "" : "plus"
                                    }`}
                                onClick={() => {
                                    this.setState({ showonwardsec: !this.state.showonwardsec });
                                }}
                            ></div>
                        </div>
                    )}
                    <div
                        className={`side-info pass seat-dtls-bg ${this.state.showonwardsec ? "" : "hide"
                            }`}
                    >
                        {Object.keys(loop).map((el) => {
                            return (
                                <div className="flexed-justify" key={el}>
                                    <div className="item-desc">Seat/Berth :{el}</div>
                                    <div className="basefare">
                                        {this.props.search.currency}
                                        {loop[el].fare - loop[el].serviceTax}
                                    </div>
                                    <div className="gst">
                                        {this.props.search.currency}
                                        {loop[el].serviceTax}
                                    </div>
                                    <div className="total">
                                        {this.props.search.currency}
                                        {loop[el].fare}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </React.Fragment>
            );
        } else {
            return <div className="side-info">Loading...</div>;
        }
    }

    showKASRTConwardFaredetails = (order) => {
        let levyFare = {};
        if (order && order.onward && order.onward.seatDetails) {
            Object.keys(order.onward.seatDetails).forEach((el) => {
                let levyList = order.onward.seatDetails[el].l || [];
                if (levyList.length > 0) {
                    levyList.forEach((el) => {
                        if (levyFare[el.n] != undefined) {
                            levyFare[el.n] += el.a;
                        } else {
                            levyFare[el.n] = el.a;
                        }
                    })
                }
            })
        }

        return (
            <React.Fragment>
                <div className="checkout--fare" style={{ position: 'relative' }}>

                    <div> {this.state.fareEng ? 'Onward Trip Fare Breakup' : 'ಹೋಗುವ ಪ್ರಯಾಣದ ದರಡ ವಿಂಗಡಣೆ'}
                        <span style={{ position: 'absolute', right: '0', cursor: 'pointer' }}>
                            <span
                                style={this.state.fareEng ? { color: '#004F9E' } : { color: '#444' }}
                                onClick={() => this.setState({ fareEng: true, fareKan: false })}
                            >EN</span>
                            <span style={{ margin: '0 4px' }}>|</span>
                            <span
                                style={this.state.fareKan ? { color: '#004F9E' } : { color: '#444' }}
                                onClick={() => this.setState({ fareEng: false, fareKan: true })}
                            >KN</span>
                        </span>
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareEng ? 'Original Basic Fare' : 'ಮೂಲ ದರ'}</div>
                    <div>{this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst}</div>
                </div>
                {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.onwardGst}</div>
        </div> */}
                <div className="checkout--fare">
                    <div>{this.state.fareEng ? 'Levies' : 'ಇತರೆ ಶುಲ್ಕಗಳು'}</div>
                    <div>{this.props.search.currency}{this.state.onwardLevyAmount}</div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareEng ? 'Concession Amount' : 'ರಿಯಾಯಿತಿ ಮೊತ್ತ'}</div>
                    <div>
                        {"-"}{this.props.search.currency}{this.state.onwardConAmt}
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareEng ? 'Total Fare' : 'ಒಟ್ಟು ಪ್ರಯಾಣದ ದರ'}</div>
                    <div>
                        {this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst + this.state.onwardLevyAmount - this.state.onwardConAmt}
                    </div>
                </div>

                {
                    Object.keys(levyFare).length > 0 &&
                    <div className="checkout--fare">
                        <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
                            {
                                Object.keys(levyFare).map((val, index) => (
                                    <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                                    </span>
                                ))
                            }
                            {`)`}</span>
                    </div>

                }

            </React.Fragment>
        )
    }

    showKASRTCreturnFaredetails = (order) => {
        let levyFare = {};
        if (order && order.return && order.return.seatDetails) {
            Object.keys(order.return.seatDetails).forEach((el) => {
                let levyList = order.return.seatDetails[el].l || [];
                if (levyList.length > 0) {
                    levyList.forEach((el) => {
                        if (levyFare[el.n] != undefined) {
                            levyFare[el.n] += el.a;
                        } else {
                            levyFare[el.n] = el.a;
                        }
                    })
                }
            })
        }
        return (
            <React.Fragment>
                <div className="checkout--fare" style={{ borderTop: '1px solid rgba(0,0,0,0.2)', position: 'relative' }}>
                    <div>{this.state.fareKanR ? 'ಮುಂದಿನ ಪ್ರಯಾಣ ದರದ ವಿರಾಮ' : 'Return Trip Fare Breakup'}
                        <span style={{ position: 'absolute', right: '0', cursor: 'pointer' }}>
                            <span
                                style={this.state.fareEngR ? { color: '#004F9E' } : { color: '#444' }}
                                onClick={() => this.setState({ fareEngR: true, fareKanR: false })}
                            >EN</span>
                            <span style={{ margin: '0 4px' }}>|</span>
                            <span
                                style={this.state.fareKanR ? { color: '#004F9E' } : { color: '#444' }}
                                onClick={() => this.setState({ fareEngR: false, fareKanR: true })}
                            >KN</span>
                        </span>
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareKanR ? 'ಮೂಲ ದರ' : 'Original Basic Fare'}</div>
                    <div>{this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst}</div>
                </div>
                {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.returnGst}</div>
        </div> */}
                <div className="checkout--fare">
                    <div>{this.state.fareKanR ? 'ಇತರೆ ಶುಲ್ಕಗಳು' : 'Levies'}</div>
                    <div>{this.props.search.currency}{this.state.returnLevyAmount}</div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareKanR ? 'ರಿಯಾಯಿತಿ ಮೊತ್ತ' : 'Concession Amount'}</div>
                    <div>
                        {"-"}{this.props.search.currency}{this.state.returnConAmt}
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.fareKanR ? 'ಒಟ್ಟು ಪ್ರಯಾಣದ ದರ' : 'Total Fare'}</div>
                    <div>
                        {this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst + this.state.returnLevyAmount - this.state.returnConAmt}
                    </div>
                </div>
                {
                    Object.keys(levyFare).length > 0 &&
                    <div className="checkout--fare">
                        <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
                            {
                                Object.keys(levyFare).map((val, index) => (
                                    <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                                    </span>
                                ))
                            }
                            {`)`}</span>
                    </div>

                }

            </React.Fragment>
        )
    }

    totalFare = () => {
        var totalFare = 0;
        totalFare =
            this.state.updatedOnwardFare +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges +
            this.state.onwardTripSrt +
            this.state.returnTripSrt;
        // console.log("totalFare", totalFare);
        return totalFare;
    };

    amountToPayBlock = () => {
        var amountToPay = 0;
        amountToPay =
            this.state.updatedOnwardFare +
            this.state.onwardLevyAmount +
            this.state.returnLevyAmount -
            this.state.onwardConAmt -
            this.state.returnConAmt +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal -
            this.state.roundTripdiscount +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges +
            this.state.onwardTripSrt -
            this.state.onwardTripSrtConcession +
            this.state.returnTripSrt -
            this.state.returnTripSrtConcession
            - this.state.discount -
            parseInt(
                this.state.CouponDiscountAmt +
                this.state.CouponDiscountAmt2 +
                this.state.CouponDiscountAmt3,
                10
            );

        // console.log("amountToPay", amountToPay);
        // console.log("round", this.state.roundTripdiscount);
        //for roundtrip and discount coupon applied
        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first add open ticket discount amount in amount to pay
                amountToPay = amountToPay + otDisAmt;
                otDisAmt = onwardTripFare;
                //then remove new open ticket discount amount in amount to pay
                amountToPay = amountToPay - otDisAmt;
            }
        }

        return amountToPay;
    };

    bankChargesCalculationBlock = () => {
        var amountToPay = this.amountToPayBlock();
        var bankCharges = Math.round(
            (this.state.bankChargesPer * amountToPay) / 100
        );
        return bankCharges;
    };

    bankChargesCalculation = () => {
        var bankCharges = this.bankChargesCalculationBlock();
        return (
            <div className="side-det">
                <div>PG Charges</div>
                <div>
                    {this.props.search.currency}
                    {bankCharges}
                </div>
            </div>
        );
    };

    getCrsDateFormatted = (val) => {
        const split = val.split("-");
        return split[0] + " " + split[1] + ", " + split[2];
    };

    checkInsurance = (e, i) => {
        const count =
            this.props.search.order.onward.seats.length +
            (this.props.search.order.return && this.props.search.order.return.seats
                ? this.props.search.order.return.seats.length
                : 0);
        const insurance = this.state.insurance === "on" ? "off" : "on";
        const totalCouponDis = parseInt(
            this.state.CouponDiscountAmt +
            this.state.CouponDiscountAmt2 +
            this.state.CouponDiscountAmt3,
            10
        );

        const insuranceVal = this.state.insurance === "on" ? 0 : count * this.props.search.order.insuranceAmt;

        const onwardInsuranceAmt = this.state.insurance === "on" ? 0 : this.props.search.order.onward.seats.length * this.props.search.order.insuranceAmt;
        const returnInsuranceAmt = this.state.insurance === "on" ? 0 : (this.props.search.order.return && this.props.search.order.return.seats
            ? this.props.search.order.return.seats.length
            : 0) * this.props.search.order.insuranceAmt;

        if (totalCouponDis > 0) {
            this.setState({ loyaltyCoupon: '', prepaidcoupon: '', marketingCoupon: '', redeemCouponsList: '', CouponName: '' }, () => { this.sendOTP() })
        }

        let alertMsg = insurance == "off" ? "You shall not have insurance for your trip." : "";

        this.setState({ insurance, insuranceVal, onwardInsuranceAmt, returnInsuranceAmt, alerterror: alertMsg });

    };

    HandleContactCheck = (e, i) => {
        // console.log("compulsory block cant uncheck");
    };
    showBankChargesConfirmBox = () => {
        var amountToPay = this.amountToPayBlock();
        var bankCharges = this.bankChargesCalculationBlock();
        var totalFare = amountToPay + bankCharges;
        var bankChargeMsg = window.confirm(
            "The bank charges for the option selected is " +
            (this.props.search.currency + bankCharges) +
            ", Total payable amount is " +
            (this.props.search.currency + totalFare)
        );
        return bankChargeMsg;
    };

    savedPassData = () => {
        let that = this;
        const savedSeatDetails = { onward: {}, return: {}, email: '', mobile: '' };
        const savedData = {};
        if (that.state.alredaySelPg) {
            let savedData = that.getSavedData();
            savedSeatDetails.onward.seatDetails = savedData.onward.seatDetails;
        } else {
            savedSeatDetails.onward.seatDetails = that.props.search.order.onward.seatDetails;
        }
        if (that.props.search.order.return) {
            if (that.state.alredaySelPg) {
                let savedData = that.getSavedData();
                savedSeatDetails.return.seatDetails = savedData.return.seatDetails;
            } else {
                savedSeatDetails.return.seatDetails = that.props.search.order.return.seatDetails;
            }
        }
        savedSeatDetails.email = that.state.email;
        savedSeatDetails.mobile = that.state.mobile;
        savedData[that.props.match.params.token] = savedSeatDetails;
        window.localStorage.setItem("savedPassDet", JSON.stringify(savedData));
    }

    getSavedData = () => {
        let that = this;
        let savedPassData = JSON.parse(localStorage.getItem('savedPassDet'));
        savedPassData = savedPassData[that.props.match.params.token]
        return savedPassData;
    }

    checkPayment = () => {
        let that = this;
        let isActive = false;
        const ord =
            this.props.search.order.length !== 0 ? this.props.search.order : false;
        if (ord) {
            let temp = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach((el) => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
            });
            if (ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach((el) => {
                    if (!returns[el].name || !returns[el].age || !returns[el].gender) {
                        temp = false;
                    }
                });
            }

            let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.email
            );
            let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
            let indianMobNo =
                (this.state.mobile + "").length === 10 &&
                /^[0]?[6789]\d{9}$/.test(this.state.mobile);
            let internationalNo =
                (this.state.mobile + "").length < 20 &&
                /^[0-9\-]+$/.test(this.state.mobile);
            let mobile =
                countryCode && this.state.countryCode === "+91"
                    ? indianMobNo
                    : internationalNo;

            if (temp === false) {
                this.setState({ alerterror: "Please enter passenger details" });
            } else if (!email) {
                this.setState({ alerterror: "Please enter valid email id" });
            } else if (!mobile) {
                this.setState({ alerterror: "Please enter valid mobile no" });
            } else if (!countryCode) {
                this.setState({ alerterror: "Please enter valid country code" });
            }

            if (
                temp &&
                email &&
                this.state.email.length > 0 &&
                mobile &&
                countryCode
            ) {
                isActive = true;
                this.setState({ payBtnDisable: true });
            }
        }

        if (!this.state.tcFlag) {
            this.setState({ alertFlag: true })
        }

        if (isActive && this.state.tcFlag) {
            that.setState({ showLoader: true });
            var confirmBox = this.state.bankChargesPer
                ? 'hidePopup'//this.showBankChargesConfirmBox()
                : true;
            if (!confirmBox) {
                this.setState({ payBtnDisable: false, showLoader: false });
                return false;
            }
            const isGenderCheck =
                window.location.search.split("p=").length > 1
                    ? window.location.search.split("p=")[1].split("&")[0]
                    : false;

            if (isGenderCheck === "1") {
                let counter = 1;
                const routeCode = this.props.search.order.onward.routeCode;
                const loop = this.props.search.order.onward.seatDetails;
                let url =
                    window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                Object.keys(loop).forEach((el) => {
                    url +=
                        "&SeatLabel_" +
                        counter +
                        "=" +
                        el +
                        "&Gender_" +
                        counter +
                        "=" +
                        ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                    counter++;
                });
                fetchGet(url)
                    .then(function (data) {
                        const response = JSON.parse(data).APIBooking_GenderValidationResult;
                        if (response.Status) {
                            that.savedPassData();
                            document.getElementById("checkoutForm").submit();
                        } else {
                            that.setState({
                                showLoader: false,
                                alerterror: response.ErrorMessage,
                            });
                            window.history.back();
                        }
                    })
                    .catch(function (error) {
                        that.setState({ showLoader: false, alerterror: error });
                    });
            } else if (
                this.props.search.order.onward.seatDetails &&
                this.props.search.order.return &&
                this.props.search.order.return.seatDetails
            ) {
                let genderResponse = { onward: false, return: false };
                // let genderError = { onward: false, return: false };

                if (this.props.search.order.onward.seatDetails) {
                    let counter = 1;
                    const routeCode = this.props.search.order.onward.routeCode;
                    const loop = this.props.search.order.onward.seatDetails;
                    let url =
                        window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                    Object.keys(loop).forEach((el) => {
                        url +=
                            "&SeatLabel_" +
                            counter +
                            "=" +
                            el +
                            "&Gender_" +
                            counter +
                            "=" +
                            ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                        counter++;
                    });
                    fetchGet(url)
                        .then(function (data) {
                            const response = JSON.parse(data)
                                .APIBooking_GenderValidationResult;
                            if (response.Status) {
                                genderResponse.onward = true;
                            } else {
                                that.setState({
                                    showLoader: false,
                                    alerterror:
                                        "Onward Trip: Seat check validation error. Please change the seat selected and try again.",
                                });
                                return;
                            }
                        })
                        .catch(function (error) {
                            that.setState({ showLoader: false, alerterror: error });
                        });
                }

                if (
                    this.props.search.order.return &&
                    this.props.search.order.return.seatDetails
                ) {
                    let counter = 1;
                    const routeCode = this.props.search.order.return.routeCode;
                    const loop = this.props.search.order.return.seatDetails;
                    let url =
                        window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                    Object.keys(loop).forEach((el) => {
                        url +=
                            "&SeatLabel_" +
                            counter +
                            "=" +
                            el +
                            "&Gender_" +
                            counter +
                            "=" +
                            ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                        counter++;
                    });
                    fetchGet(url)
                        .then(function (data) {
                            const response = JSON.parse(data)
                                .APIBooking_GenderValidationResult;
                            if (response.Status) {
                                that.savedPassData();
                                document.getElementById("checkoutForm").submit();
                            } else {
                                that.setState({
                                    showLoader: false,
                                    alerterror:
                                        "Return Trip: Seat check validation error. Please change the seat selected and try again.",
                                });
                                return;
                            }
                        })
                        .catch(function (error) {
                            that.setState({ showLoader: false, alerterror: error });
                        });
                }
            } else {
                let that = this;
                that.savedPassData();
                document.getElementById("checkoutForm").submit();
            }
        }
    };

    getMobile = () => {
        let mob = this.props.search.contactDetail.mobile.replace(/\-/g, "");
        const mobNo =
            this.state.countryCode === "+91" ? mob : this.state.countryCode + mob;
        return mobNo;
    };

    showOpDiscountConfirmBox = () => {
        if (this.state.showConfirm) {
            const r = window.confirm(
                "Operator discount has been changed, Do you want to continue with new discount?"
            );
            if (r !== true) {
                const url =
                    window.url +
                    apiUrl.orderDetails +
                    "token=" +
                    this.props.match.params.token;
                const that = this;
                fetchGet(url)
                    .then(function (data) {
                        var info;
                        var mode = "";
                        if (that.state.updatedReturnFare) {
                            info = data.return;
                            mode = "roundtrip";
                        } else {
                            info = data.onward;
                            mode = "oneway";
                        }
                        var fromCityId = info.fromCityId,
                            fromCity = info.fromCity,
                            toCityId = info.toCityId,
                            toCity = info.toCity,
                            departDate = getDateForSrch(info.journeyDate),
                            rsid = info.routeCode,
                            cid = info.companyId;

                        that.props.history.push(
                            "/search?mode=" +
                            mode +
                            "&fromCity=" +
                            fromCityId +
                            "|" +
                            fromCity +
                            "&toCity=" +
                            toCityId +
                            "|" +
                            toCity +
                            "&departDate=" +
                            departDate +
                            "&returnDate=&" +
                            "hop=direct&rsid=" +
                            rsid +
                            "&cid=" +
                            cid +
                            "&src=chkhld&e=-1&apiName=crs"
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            this.setState({ showConfirm: false });
        }
    };

    apiCouponListNew = () => {
        let that = this;
        let routeCode = that.props.search.order.onward.routeCode;
        let mobile =
            window.customerProfile && window.customerProfile.MobileNumber
                ? window.customerProfile.MobileNumber
                : that.state.mobile;
        let url =
            window.url +
            apiUrl.couponList +
            "?RouteCode=" +
            routeCode +
            "&MobileNumber=" +
            mobile +
            "&EmailID=&CouponName";
        that.setState({ showLoader: true });
        fetchGet(url)
            .then(function (data) {
                that.setState({ showLoader: false });
                store.dispatch(couponListDetails(data));
                that.setState({ getCouponsDetails: true });
            })
            .catch(function (error) {
                that.setState({ showLoader: false });
                console.log(error);
            });
    };

    showaertdialogue = () => {
        setTimeout(() => {
            this.setState({ alerterror: "" });
        }, 5000);
        return (
            <div
                className="blacklayer"
                onClick={() => {
                    this.setState({ alerterror: "" });
                }}
            >
                <div className="popupbox">
                    {/* <div className="circle pixedpos logo-box">
            <GsbLogoBold />
          </div> */}
                    <div className="alertmsg">{this.state.alerterror}</div>
                    <button
                        className="alertbuttonok crsrpointer"
                        onClick={() => {
                            this.setState({ alerterror: "" });
                        }}
                    >
                        OK{" "}
                    </button>
                </div>
            </div>
        );
    };

    HandleTandCCheck = () => {
        let checkTandC = this.state.checkTandC;
        this.setState({ checkTandC: !checkTandC, payopt: '', bankChargesPer: 0 })
    }

    updateUrl = (page) => {
        const pathname = window.location.pathname;
        const queryParam = window.location.search;
        let url = pathname + queryParam;
        if (page === 'payment') {
            url = pathname + queryParam.split('&')[0] + '&page=payment';
        } else {
            url = pathname + queryParam.split('&')[0];
        }
        this.props.history.push(url);
    }

    validatePayeeDetail = () => {
        let loginType = this.state.loginType;
        let validationError = [];
        let temp = true;
        let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
        let indianMobNo =
            (this.state.mobile + "").length === 10 &&
            /^[0]?[6789]\d{9}$/.test(this.state.mobile);
        let internationalNo =
            (this.state.mobile + "").length < 20 &&
            /^[0-9\-]+$/.test(this.state.mobile);
        let mobile =
            countryCode && this.state.countryCode === "+91"
                ? indianMobNo
                : internationalNo;
        let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            this.state.email
        );
        if (this.state.countryCode === "" && loginType === 'guest') {
            validationError.push(" country code");
            temp = false;
        }
        if (this.state.mobile === "" && loginType === 'guest') {
            validationError.push(" mobile no");
            temp = false;
        }
        if (this.state.email === "") {
            validationError.push(" email id");
            temp = false;
        }
        if (this.state.password === "" && loginType === 'login') {
            validationError.push("password");
            temp = false;
        }
        if (!mobile && this.state.mobile !== "" && loginType === 'guest') {
            validationError.push(" valid mobile no");
            temp = false;
        } else if (!email && this.state.email !== "") {
            validationError.push(" valid email id");
            temp = false;
        } else {
            // var gstValidation = this.checkGst();
            // if (gstValidation === false) {
            //     validationError.push(" valid GSTN");
            //     temp = false;
            // }
        }
        if (temp === false) {
            this.setState({ alerterror: "Kindly enter " + validationError });
            return false;
        } else {
            return temp;
        }
    };

    handlePayee = () => {

        this.validatePayeeDetail() && [
            // this.updateUrl("payment"),
            this.setState({
                activeNavTab: "passengerlist",
                payeedetail: true,
            })
        ]
    }


    reviewInfo = () => {
        let order = this.props.search.order;
        let onward = order && order.onward;
        let ret = order && order.return;
        let tripData = JSON.parse(localStorage.getItem('tripData'));
        return (
            <React.Fragment>
                <div className="pass--info" style={{ display: 'flex', marginTop: '16px', position: 'relative' }}>
                    <LineInp
                        type="text"
                        value={this.state.email || ""}
                        handleChange={(e) => this.setState({ email: e.target.value })}
                        placeholder="Email ID"
                        name="Email ID"
                        validation="email"
                        style={{ width: "calc(33%)", marginRight: "10px" }}
                    />
                    <LineInp
                        type="number"
                        value={this.state.mobile || ""}
                        handleChange={(e) => this.setState({ mobile: e.target.value })}
                        placeholder="Contact Number"
                        name="Contact Number"
                        validation="mobile"
                        style={{ width: "calc(33%)", marginRight: "10px" }}
                    />
                    <div className="review-text-wrap" style={{ position: 'absolute', right: '0', display: 'flex', cursor: 'pointer' }}>
                        <div
                            style={this.state.reviewEng ? { color: '#004F9E' } : { color: '#444' }}
                            onClick={() => this.setState({ reviewEng: true, reviewKan: false })}
                        > English </div>
                        <div style={{ margin: '0 4px' }}> {" | "} </div>
                        <div
                            style={this.state.reviewKan ? { color: '#004F9E' } : { color: '#444' }}
                            onClick={() => this.setState({ reviewEng: false, reviewKan: true })}
                        > Kannada</div>
                    </div>
                </div>

                <div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 8px 0', borderBottom: '1px solid rgba(0,0,0,0.2)' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', letterSpacing: '.02rem', color: '#202020' }}>Onward Trip Booking Review </div>
                    <div style={{ fontSize: '12px', fontWeight: '500', lineHeight: '16px', letterSpacing: '.02rem', color: '#444' }}>Booking as: {window.customerProfile.isLoggedIn ? 'Logged in User' : 'Guest'}</div>
                </div>

                {onward &&
                    <div className="review--content">
                        <div className="left">
                            <div className="content">
                                <div>{this.state.reviewEng ? 'OB Reference' : 'OB Reference'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{order.orderId}</div>
                            </div>
                            <div className="content" style={{ display: 'flex' }}>
                                <div>{this.state.reviewEng ? 'Date of Journey' : 'ಪ್ರಯಾಣದ ದಿನಾಂಕ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.journeyDate}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Start Place' : 'ಪ್ರಾರಂಭ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.fromCity}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Boarding Point' : 'ಹತ್ತುವ ಸ್ಥಳಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.boardingPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Total Seats' : 'ಒಟ್ಟು ಆಸನಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.seats.length}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Departure Time' : 'ನಿರ್ಗಮನ ಸಮಯ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.boardingTime}</div>
                            </div>
                        </div>
                        <div className="right" style={{ width: '50%' }}>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Trip Code' : 'ಟ್ರಿಪ್ ಕೋಡ್'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.onward.tripCode}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Class of Service' : 'ಸಾರಿಗೆಯ ವರ್ಗ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.onward.busServiceType}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'End Place' : 'ಗಮ್ಯ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.toCity}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Alighting Point' : 'ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.dropPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Seat Number' : 'ಆಸನ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.seats.join(',')}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Platform Number' : 'ಅಂಕಣ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{"-"}</div>
                            </div>
                        </div>
                    </div>
                }

                {ret && <div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 8px 0', borderBottom: '1px solid rgba(0,0,0,0.2)' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', letterSpacing: '.02rem', color: '#202020' }}>Return Trip Booking Review </div>
                    <div style={{ fontSize: '12px', fontWeight: '500', lineHeight: '16px', letterSpacing: '.02rem', color: '#444' }}>Booking as: {window.customerProfile.isLoggedIn ? 'Logged in User' : 'Guest'}</div>
                </div>
                }

                {ret && Object.keys(ret).length > 0 &&
                    <div className="review--content">
                        <div className="left">
                            <div className="content">
                                <div>{this.state.reviewEng ? 'OB Reference' : 'OB Reference'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{order.orderId}</div>
                            </div>
                            <div className="content" style={{ display: 'flex' }}>
                                <div>{this.state.reviewEng ? 'Date of Journey' : 'ಪ್ರಯಾಣದ ದಿನಾಂಕ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.journeyDate}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Start Place' : 'ಪ್ರಾರಂಭ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.fromCity}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Boarding Point' : 'ಹತ್ತುವ ಸ್ಥಳಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.boardingPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Total Seats' : 'ಒಟ್ಟು ಆಸನಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.seats.length}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Departure Time' : 'ನಿರ್ಗಮನ ಸಮಯ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.boardingTime}</div>
                            </div>
                        </div>
                        <div className="right" style={{ width: '50%' }}>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Trip Code' : 'ಟ್ರಿಪ್ ಕೋಡ್'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.return.tripCode}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Class of Service' : 'ಸಾರಿಗೆಯ ವರ್ಗ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.return.busServiceType}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'End Place' : 'ಗಮ್ಯ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.toCity}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Alighting Point' : 'ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.dropPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Seat Number' : 'ಆಸನ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.seats.join(',')}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Platform Number' : 'ಅಂಕಣ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{"-"}</div>
                            </div>
                        </div>
                    </div>
                }

            </React.Fragment>
        )
    }

    setTncFLag = (value) => {
        this.setState({ tcFlag: value })
    }

    render() {
        // console.log("order", this.props.search.order);
        // console.log("props", this.props);
        // console.log("onwardConcessionUsed", this.state.onwardConcessionUsed);
        // console.log("onwardLevyConcDetails", this.props.search.levyandConcData);
        // console.log("updatedOnwardFare", this.state.updatedOnwardFare);
        // console.log("updatedRetrunFare", this.state.updatedReturnFare);

        let that = this;
        that.showOpDiscountConfirmBox();
        let amountToPay = 0;
        amountToPay =
            that.state.updatedOnwardFare +
            that.state.updatedReturnFare +
            that.state.onwardSc +
            that.state.returnSc +
            that.state.onwardGst +
            that.state.returnGst +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges -
            this.state.roundTripdiscount +
            that.state.insuranceVal -
            that.state.discount -
            parseInt(
                that.state.CouponDiscountAmt +
                that.state.CouponDiscountAmt2 +
                that.state.CouponDiscountAmt3,
                10
            );
        var bankCharges = Math.ceil(
            (that.state.bankChargesPer * amountToPay) / 100
        );
        // console.log("oowow", this.props)

        const order = this.props.search.order;
        return (
            <div key="checkoutpage">
                {/* {window.msurl === 'shrinath.biz' ? <HeaderSTA /> : <Header />} */}
                <HeaderNew />
                {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
                <section className="checkout-wrapper" key="checkout-wrapper">
                    <div className="left-div" key="3ss" style={{ width: '70%' }}>
                        <form
                            key="dssfd"
                            id="checkoutForm"
                            method="POST"
                            action={window.url + "/co/confirm"}
                        >
                            <input type="hidden" name="query" value={that.state.queryData} />
                            <input
                                type="hidden"
                                name="o"
                                id="o"
                                value={that.props.match.params.token}
                            />
                            <input type="hidden" name="owo" value="0" />
                            <input type="hidden" name="method" id="method" value="1" />
                            <input type="hidden" name="provider" id="provider" value="1" />
                            <input
                                type="hidden"
                                name="hd_charges"
                                id="hd_charges"
                                value="0"
                            />
                            <input
                                type="hidden"
                                name="coupon"
                                id="coupon"
                                value={this.state.validCouponName}
                            />
                            <input
                                type="hidden"
                                name="countrycode"
                                id="countrycode"
                                value={"+91"}
                            />
                            <input
                                type="hidden"
                                name="mobile"
                                id="mobile"
                                value={that.state.mobile}
                            />
                            <input
                                type="hidden"
                                name="mobileNo"
                                id="mobileNo"
                                value={that.state.mobile}
                            />
                            <input
                                type="hidden"
                                name="email"
                                id="email"
                                value={that.state.email}
                            />
                            <input
                                type="hidden"
                                name="couponID"
                                id="couponID"
                                value={that.state.CouponID}
                            />
                            <input
                                type="hidden"
                                name="couponID2"
                                id="couponID2"
                                value={that.state.CouponID2}
                            />
                            <input
                                type="hidden"
                                name="couponID3"
                                id="couponID3"
                                value={that.state.CouponID3}
                            />
                            <input
                                type="hidden"
                                name="couponAmount"
                                id="couponAmount"
                                value={that.state.CouponDiscountAmt}
                            />
                            <input
                                type="hidden"
                                name="couponAmount2"
                                id="couponAmount2"
                                value={that.state.CouponDiscountAmt2}
                            />
                            <input
                                type="hidden"
                                name="couponAmount3"
                                id="couponAmount3"
                                value={that.state.CouponDiscountAmt3}
                            />
                            {that.props.search.order.showInsurance && (
                                <input
                                    type="hidden"
                                    name="insurance"
                                    value={that.state.insurance}
                                />
                            )}

                            {
                                order && order.onward && order.onward.seatDetails && Object.keys(order.onward.seatDetails).length > 0 && Object.keys(order.onward.seatDetails).map((el, index) => (
                                    <React.Fragment key={el}>
                                        <input type='hidden' name={`paxName[${index}]`} value={order.onward.seatDetails[el].name || ''} />
                                        <input type='hidden' name={`paxGender[${index}]`} value={order.onward.seatDetails[el].gender || ''} />
                                        <input type='hidden' name={`paxAge[${index}]`} value={order.onward.seatDetails[el].age || ''} />
                                        <input type='hidden' name={`paxConcessionType[${index}]`} value={order.onward.seatDetails[el].concessionType || ''} />
                                        <input type='hidden' name={`paxIDCardNo[${index}]`} value={order.onward.seatDetails[el].idCardNo || ''} />
                                        <input type='hidden' name={`paxIDCardType[${index}]`} value={order.onward.seatDetails[el].idCardType || ''} />
                                        <input type='hidden' name={`paxNationality[${index}]`} value={order.onward.seatDetails[el].nationality || ''} />
                                    </React.Fragment>
                                ))

                            }
                            <input type="hidden" name="PGType" value={this.state.payopt} />
                            <div className="tdnav flex">

                                <div
                                    className={`tdnav-item crsrpointer flex-all-c border-lr ${this.state.activeNavTab === "review" ? "activenav" : ""
                                        } ${this.state.activeNavTab === 'payment' ? "donesec" : ""}`}
                                    style={{ width: '50%' }}
                                    onClick={() => {
                                        this.setState({ activeNavTab: "review" })
                                    }}
                                >
                                    1. Review Booking
                                    {this.state.reviewDetail && (
                                        <span className="greentickmark"></span>
                                    )}
                                </div>

                                <div
                                    className={`tdnav-item crsrpointer flex-all-c ${this.state.activeNavTab === "payment" ||
                                        this.state.activeNavTab === ""
                                        ? "activenav"
                                        : ""
                                        } ${this.state.payment ? "donesec" : ""}`}
                                    style={{ width: '50%' }}
                                    onClick={() => {

                                        this.state.reviewDetail && [
                                            // this.updateUrl('userdetail'),
                                            this.setState({ activeNavTab: "payment" })]

                                    }}
                                >
                                    2. Payment Gateway
                                </div>
                            </div>

                            <div key="334sa43">

                                <div
                                    key="was43"
                                    className={
                                        this.state.activeNavTab === "" ||
                                            this.state.activeNavTab === "review"
                                            ? "block"
                                            : "inactive"
                                    }
                                >
                                    <div className="card" key="reviewdeatils">
                                        {this.reviewInfo()}
                                    </div>

                                    <div
                                        className={`navswitchbtn flex-all-c`}
                                        onClick={() => {
                                            this.validatePayeeDetail() && [
                                                this.setState({
                                                    activeNavTab: "payment",
                                                    reviewDetail: true,
                                                })
                                            ]
                                        }}
                                    >
                                        proceed to payment gateway
                                        {/* {!this.state.getCouponsDetails ? 'PROCEED TO PAYEE DETAILS' : 'PROCEED TO PAYEE & DISCOUNT DETAILS'} */}
                                    </div>
                                </div>
                                <div
                                    className={
                                        this.state.activeNavTab === "payment" ? "block" : "inactive"
                                    }
                                >
                                    {that.selPaymentOption()}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="right-div" style={{ width: '30%' }}>
                        <div className="tdnav flex">
                            <div
                                className={`rt-item flex-all-c ${this.state.activeRtTab === "farebreakup" ? "activenav" : ""
                                    }`}
                                onClick={() => {
                                    this.setState({ activeRtTab: "farebreakup" });
                                }}
                            >
                                Fare Breakup
                            </div>
                            <div
                                className={`rt-item flex-all-c ${this.state.activeRtTab === "bookingdetail" ? "activenav" : ""
                                    }`}
                                onClick={() => {
                                    this.setState({ activeRtTab: "bookingdetail" });
                                }}
                            >
                                Booking Details
                            </div>
                        </div>
                        <div>
                            <div
                                className={
                                    this.state.activeRtTab === "" ||
                                        this.state.activeRtTab === "farebreakup"
                                        ? "block"
                                        : "inactive"
                                }
                            >
                                <div className="card">
                                    <div className="onwarddata">
                                        {/* <div className="fare-header flex-vc flexed-justify">
                      <div className="item-desc">Item desc</div>
                      <div className="basefare">Base Fare</div>
                      <div className="gst">GST</div>
                      <div className="total">Total</div>
                    </div> */}
                                        {/* {that.showOnwardPassDetails()} */}
                                        {/* {that.showKsrtcOnwardPassDetails()} */}
                                        {that.showKASRTConwardFaredetails(that.props.search.order)}
                                        {/*that.showOnwardFareDetails()*/}
                                    </div>
                                    <div className="returndata">
                                        {that.props.search.order.length !== 0 &&
                                            that.props.search.order.return &&
                                            that.props.search.order.return.seats
                                            ? [that.showKASRTCreturnFaredetails(that.props.search.order)]
                                            : ""}
                                    </div>
                                    {/* {that.showKsrtcFarelabel()} */}
                                    {this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.returnPickcharges + this.state.returnDropcharges !== 0 ? (
                                        <div
                                            className="side-info fare">
                                            <div className="side-det">
                                                <div style={{ width: "80%", display: "inline-block" }}>
                                                    Pickup / Drop Charges&nbsp;
                                                </div>
                                                <div
                                                    style={{
                                                        width: "20%",
                                                        display: "inline-block",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {this.props.search.currency}
                                                    {this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.returnPickcharges + this.state.returnDropcharges}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {this.state.showServiceCharge && (this.state.onwardSc + this.state.returnSc) > 0 ? (
                                        <div
                                            className="side-info fare">
                                            <div className="side-det">
                                                <div style={{ width: "80%", display: "inline-block" }}>
                                                    Service Charge&nbsp;
                                                </div>
                                                <div
                                                    style={{
                                                        width: "20%",
                                                        display: "inline-block",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {this.props.search.currency}
                                                    {this.state.onwardSc + this.state.returnSc}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {this.state.onwardConvenienceCharge + this.state.returnConvenienceCharge !== 0 ? (
                                        <div
                                            className="side-info fare">
                                            <div className="side-det">
                                                <div style={{ width: "80%", display: "inline-block" }}>
                                                    Convenience Charge&nbsp;
                                                </div>
                                                <div
                                                    style={{
                                                        width: "20%",
                                                        display: "inline-block",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {this.props.search.currency}
                                                    {this.state.onwardConvenienceCharge + this.state.returnConvenienceCharge}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {this.props.search.order.showInsurance ? (
                                        <div
                                            className="side-info fare">
                                            <div className="side-det">
                                                <div>Travel Insurance</div>
                                                <div>
                                                    {this.props.search.currency}
                                                    {this.state.insuranceVal}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                </div>
                                <div className="final--amount--paid"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        background: '#fff',
                                        height: '70px',
                                        fontWeight: '600',
                                        borderRadius: ' 0 0 6px 6px',
                                        color: '#FF7100',
                                        padding: '0 25px',
                                        alignItems: 'center',
                                        borderTop: '1px solid rgba(0,0,0,0.2)'
                                    }}>
                                    <div>{this.state.fareEng ? 'Amount to be Paid' : 'ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ'}</div>
                                    <div>{that.props.search.currency}{this.amountToPayBlock() + this.bankChargesCalculationBlock()}</div>
                                </div>
                            </div>
                            <div
                                className={
                                    this.state.activeRtTab === "bookingdetail"
                                        ? "block"
                                        : "inactive"
                                }
                            >
                                <div className="card">
                                    {that.showOnwardTripDetails()}
                                    {that.props.search.order.length !== 0 &&
                                        that.props.search.order.return &&
                                        that.props.search.order.return.seats
                                        ? that.showReturnTripDetails()
                                        : ""}
                                </div>
                                {/* <div className="infoswitchbtn flex-vc">
                  <div className="flex-vc" style={{ filter: "grayscale(1)" }}>
                    <Check
                      value={this.state.insurance}
                      checked={true}
                      handleChange={this.HandleContactCheck}
                      style={{ padding: "1px 5px" }}
                    />
                    *Payee agree to be contacted on mobile ( even if its DND) and email for
                    all types of messages and calls
                  </div>
                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
                {window.msurl === 'shrinath.biz' ? <FooterSTA /> : <Footer />}
                {that.state.showLoader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {this.state.alertFlag &&
                    < AlertTerms
                        msg={"hello roushan"}
                        error={false}
                        className="login--alert"
                        setTncFLag={this.setTncFLag}
                        close={() => {
                            this.setState({ alertFlag: false })
                        }}
                    />

                }
            </div>
        );

    }
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(CheckoutNew);
